const messages = {
  en: {
    playAll: 'Play all',
    prev: 'Previous step',
    next: 'Next step',
    flashError: 'Images for this tutorial are not supported on your browser.'
  },
  es: {
    playAll: 'Reproducir todos',
    prev: 'Paso previo',
    next: 'Próximo paso',
    flashError:
      'Las imágenes de este tutorial no son compatibles con este dispositivo.'
  }
}

export default messages
